import React from "react";

const ModalWrapperMid = ({
  children, handleToggleModal
}) => {

  return (
    <>
      <div className="storefront-modal-wrapper-mid" onClick={handleToggleModal}>
        <div className="storefront-modal-wrapper-mid-container" onClick={(e) => e.stopPropagation()}>
          {children}
        </div>
      </div>
    </>
  );
};

export default ModalWrapperMid;
